"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.unGzipBase64AsJson = exports.gzipDecompressToString = exports.base64ToArrayBuffer = exports.convert = void 0;
var utils_1 = require("./utils");
Object.defineProperty(exports, "convert", { enumerable: true, get: function () { return utils_1.convert; } });
Object.defineProperty(exports, "base64ToArrayBuffer", { enumerable: true, get: function () { return utils_1.base64ToArrayBuffer; } });
Object.defineProperty(exports, "gzipDecompressToString", { enumerable: true, get: function () { return utils_1.gzipDecompressToString; } });
var commonUtils_1 = require("./commonUtils");
Object.defineProperty(exports, "unGzipBase64AsJson", { enumerable: true, get: function () { return commonUtils_1.unGzipBase64AsJson; } });
